'use strict';

wbApp.factory('courseDetailSvc', [
    '$http', 'notificationSvc', '$translate', '$timeout', 'tenantSettingSvc', 'courseRegistrationCommonSvc',
    function ($http, notificationSvc, $translate, $timeout, tenantSettingSvc, courseRegistrationCommonSvc) {

        function askQuestionAboutCourse(courseID, emailAddress, question, onSuccess, onError) {
            $http({
                method: 'POST',
                url: '/Courses/AskQuestionAboutCourse',
                data: {
                    courseID: courseID,
                    emailAddress: emailAddress,
                    question: question
                }
            })
            .success(function (actionDetail, status, headers, config) {
                if (onSuccess) {
                    onSuccess();
                }

                notificationSvc.notifyInfo(
                    $translate.instant('TXT_ALERT_TITLE_REGISTERING_USER_QUESTION_SUCCESS'));
            })
            .error(function (errorResult, status, headers, config) {
                if (onError) {
                    onError(errorResult);
                }

                notificationSvc.notifyError(
                    $translate.instant('TXT_ALERT_TITLE_REGISTERING_USER_QUESTION_FAILURE'),
                    notificationSvc.translateError(errorResult));
            });
        }

        function savePreviewAttendanceChange(studentID, courseScheduleID, courseID, onSuccess) {
            $http({
                method: 'POST',
                url: '/Api/UserSchedule/ChangePreviewAttendance',
                params: { StudentID: studentID, CourseScheduleID: courseScheduleID, CourseID: courseID }
            })
            .success(function (schedules, status, headers, config) {
                
                var selected;
                angular.forEach(schedules, function (value, key) {
                    if (value.courseScheduleID === courseScheduleID) {
                        selected = value;
                    }
                });

                if (onSuccess) {
                    onSuccess(schedules, selected);
                }

                notificationSvc.notifyInfo(
                    $translate.instant('TXT_ALERT_TITLE_COURSE_PREVIEW_ATTENDANCE_CHANGE_SUCCESS'));

            })
            .error(function (errorResult, status, headers, config) {
                notificationSvc.notifyError(
                    $translate.instant('TXT_ALERT_TITLE_COURSE_PREVIEW_ATTENDANCE_CHANGE_FAILURE'),
                    notificationSvc.translateError(errorResult));
            });
        }

        function getConfirmRegistrationDescription(students, origStudents, course) {
            return courseRegistrationCommonSvc.getConfirmRegistrationDescription(students, origStudents, course, false);
        }

        function switchToTab(tabs, tabName) {
            var tabIndexToActivate = _.findIndex(tabs, { name: tabName });
            if (tabIndexToActivate !== -1 && tabs.activeTab !== tabIndexToActivate) {
                tabs.activeTab = tabIndexToActivate;
                $timeout(function () {
                    tabs.activeTab = tabIndexToActivate;
                });
                return;
            }
        }

        function addTabIfNotExist(tabs, template, name, title) {
            var idx = _.findIndex(tabs, { template: template });
            if (idx === -1) {
                tabs.push(
                    {
                        title: title,
                        name: name,
                        template: template,
                        disabled: false
                    });
                idx = tabs.length - 1;
            }
        }

        var bookPreviewTabTemplate = 'courses/book-preview-tab.html';
        var bookCourseTabTemplate = 'courses/book-course-tab.html';
        var bookInterestTabTemplate = 'courses/book-interest-tab.html';
        var quickUserRegistrationTabTemplate = 'courses/quick-user-registration-tab.html';

        function isOnSpecificTabByTemplate(tabs, template, newIndex) {
            return _.findIndex(tabs, { template: template }) == newIndex;
        }

        function isOnBookCourseTab(tabs, newIndex) {
            return isOnSpecificTabByTemplate(tabs, bookCourseTabTemplate, newIndex);
        }

        function isOnBookInterestTab(tabs, newIndex) {
            return isOnSpecificTabByTemplate(tabs, bookInterestTabTemplate, newIndex);
        }

        function isOnBookPreviewTab(tabs, newIndex) {
            return isOnSpecificTabByTemplate(tabs, bookPreviewTabTemplate, newIndex);
        }

        function addBookPreviewTabIfNeeded(tabs) {
            if (tenantSettingSvc.settings.coursePreviewOnlyRegistration) {
                addTabIfNotExist(
                    tabs,
                    bookPreviewTabTemplate,
                    'book-preview',
                    'TXT_TAB_BOOK_PREVIEW');
            }
        }

        function addBookCourseTabIfNeeded(tabs) {
            if (tenantSettingSvc.settings.allowClientCourseRegistration &&
                !tenantSettingSvc.settings.courseInterestsSupport) {

                addTabIfNotExist(
                    tabs,
                    bookCourseTabTemplate,
                    'book-course',
                    'TXT_TAB_BOOKING');
            }
        }

        function addBookInterestTabIfNeeded(tabs) {
            if (tenantSettingSvc.settings.courseInterestsSupport) {

                addTabIfNotExist(
                    tabs,
                    bookInterestTabTemplate,
                    'book-interest',
                    'TXT_TAB_BOOKING');
            }
        }

        function addQuickUserRegistrationTabIfNeeded(tabs) {
            addTabIfNotExist(
                tabs,
                quickUserRegistrationTabTemplate,
                'user-quick-registration',
                'TXT_TITLE_LOGIN');
        }

        function switchToBookPreviewTab(tabs) {
            switchToTab(tabs, 'book-preview');
        }

        function switchToCourseRegistrationTab(tabs) {
            switchToTab(tabs, 'book-course');
        }

        function switchToQuickUserRegistrationTab(tabs) {
            switchToTab(tabs, 'user-quick-registration');
        }

        return {
            savePreviewAttendanceChange: savePreviewAttendanceChange,
            getConfirmRegistrationDescription: getConfirmRegistrationDescription,           
            askQuestionAboutCourse: askQuestionAboutCourse,

            addBookPreviewTabIfNeeded: addBookPreviewTabIfNeeded,
            addBookCourseTabIfNeeded: addBookCourseTabIfNeeded,
            addBookInterestTabIfNeeded: addBookInterestTabIfNeeded,
            addQuickUserRegistrationTabIfNeeded: addQuickUserRegistrationTabIfNeeded,
            switchToBookPreviewTab: switchToBookPreviewTab,
            switchToCourseRegistrationTab: switchToCourseRegistrationTab,
            switchToQuickUserRegistrationTab: switchToQuickUserRegistrationTab,

            isOnBookCourseTab: isOnBookCourseTab,
            isOnBookInterestTab: isOnBookInterestTab,
            isOnBookPreviewTab: isOnBookPreviewTab
        }
    }]);
